module.exports = __webpack_public_path__ + "img/shoot_00027.14706453.png";